// AI-ASSISTED: generated with claude-code on 2026-06-03, reviewed by Yoann Hertienne
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

export const redirectModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/',
        loader: async () => {
          const { HomeRedirect } = await import('./HomeRedirect');
          return <HomeRedirect />;
        },
      },
    }),
  ],
});
